import { fmtDate } from "../../extensions/utils";
import { isMobile } from "../../extensions/design";
import { Card, Typography } from "antd";
const { Text } = Typography;

const ClientItemPayment = ({ item, onClick }) => {
  return<div className="client-item-sale" onClick={onClick}>
    <div className="client-item-body">
      <div className="client-item-line-bold-double">
        <div className="client-item-clip">{item.productName || item.paymentVid2Name}</div>
        <div className="client-item-clip-right" style={item.vid === 1 || item.vid === 2 ? {color:"green"} : item.vid === -1 ? {color:"red"} : {}}>{item.syma}</div>
      </div>
      <div className="client-item-line-double-halfed">
        <div className="client-item-clip">Касса {item.paymentVidName}</div>
        <div className="client-item-clip">{item.vid === 1 ? "Оплата" : item.vid === -1 ? "Возврат" : item.vid === 2 ? "Пополнение" : "???"} {fmtDate(item.docDate)}</div>
      </div>
    </div>
  </div>
}

export default ClientItemPayment;